import { WA_PHONE, WA_BUTTONS, META_EVENT_NAME } from "@/content";

/** Construye el enlace de WhatsApp con mensaje pre-cargado + UTM por botón */
export function waLink(key) {
  const cfg = WA_BUTTONS[key] || WA_BUTTONS.flotante;
  const params = new URLSearchParams();
  params.set("text", cfg.msg);
  if (cfg.utm) {
    if (cfg.utm.source) params.set("utm_source", cfg.utm.source);
    if (cfg.utm.medium) params.set("utm_medium", cfg.utm.medium);
    if (cfg.utm.campaign) params.set("utm_campaign", cfg.utm.campaign);
    if (cfg.utm.content) params.set("utm_content", cfg.utm.content);
  }
  return `https://wa.me/${WA_PHONE}?${params.toString()}`;
}

export function waLabel(key) {
  const cfg = WA_BUTTONS[key] || WA_BUTTONS.flotante;
  return cfg.label;
}

/** Evento personalizado del píxel de Meta en cada clic de WhatsApp */
export function trackWhatsApp(key, extra = {}) {
  const cfg = WA_BUTTONS[key] || {};
  const payload = {
    seccion: key,
    ...(cfg.utm || {}),
    ...extra,
  };
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("trackCustom", META_EVENT_NAME, payload);
    }
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: META_EVENT_NAME, ...payload });
    }
  } catch (e) {
    /* nunca bloquear el clic por analítica */
  }
}
